export default "__VITE_ASSET__DygGOEEw__"